import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('ancillary_rate_factor_set_publish',
  baseUrl,
  'id')
const actions = generator.generate()

function baseUrl() {
  return '/ancillary_rate_factor_sets/publish'
}

export default actions
